import { Box, Flex, Link, Text, IconButton, Collapse, VStack, useDisclosure } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

function Navbar() {
  const { isOpen, onToggle } = useDisclosure();

  const NavLinks = () => (
    <VStack spacing={4} align="stretch" py={4}>
      <Link as={RouterLink} to="/find-teacher" color="gray.700" _hover={{ color: 'teal.800' }}>
        Find My Teacher
      </Link>
      <Link as={RouterLink} to="/teach" color="gray.700" _hover={{ color: 'teal.800' }}>
        Teach For Us
      </Link>
      <Link as={RouterLink} to="/about" color="gray.700" _hover={{ color: 'teal.800' }}>
        About
      </Link>
    </VStack>
  );

  return (
    <Box bg="white" boxShadow="sm">
      <Flex maxW="1200px" mx="auto" px={4} py={3} align="center" justify="space-between">
        <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
          <Text fontSize="xl" fontWeight="bold" color="teal.800">
            Mock Me, Please!
          </Text>
        </Link>

        {/* Desktop Navigation */}
        <Flex gap={8} display={{ base: 'none', md: 'flex' }}>
          <Link as={RouterLink} to="/find-teacher" color="gray.700" _hover={{ color: 'teal.800' }}>
            Find My Teacher
          </Link>
          <Link as={RouterLink} to="/teach" color="gray.700" _hover={{ color: 'teal.800' }}>
            Teach For Us
          </Link>
          <Link as={RouterLink} to="/about" color="gray.700" _hover={{ color: 'teal.800' }}>
            About
          </Link>
        </Flex>

        {/* Mobile Menu Button */}
        <IconButton
          display={{ base: 'flex', md: 'none' }}
          onClick={onToggle}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          variant="ghost"
          aria-label="Toggle menu"
          color="teal.800"
        />
      </Flex>

      {/* Mobile Navigation */}
      <Collapse in={isOpen} animateOpacity>
        <Box display={{ base: 'block', md: 'none' }} bg="white" px={4} pb={4}>
          <NavLinks />
        </Box>
      </Collapse>
    </Box>
  );
}

export default Navbar; 